<template>
  <template v-if="layout == 'images'">
  <ul class="glass-item-colors">
    <li v-for="(color, index) in colors" :key="index">

      <a @click="$emit('colorClicked', index)"
         :data-idx="index">
        <img class="img-cropped" :src="getImage(color)" />
        <div class="color-switcher-title">
          col. {{ color.color_nr }}
        </div>
      </a>
    </li>
  </ul>
  </template>
  <template v-else>
    <ul class="glass-item-colors">
      <li v-for="(color, index) in colors" :key="index">
        <a @click="$emit('colorClicked', index)" :class="'color-icon color-' + color.class"
           :data-idx="index"></a>
      </li>
    </ul>

  </template>
</template>
<script>
import {computed} from 'vue'
import config from "@/config";
import {getImageName} from '@/composable/eonUtils'
export default {
  name: "GlassColorSelect",
  props: {
    Colors: Array,
    Layout: String,
  },
  setup(props) {
    const colors = computed(() => {
      return props.Colors
    })
    const layout = computed(() => {
      return props.Layout
    })

    return {
      colors,
      layout,
      getImageName
    }
  },
  methods: {

    getImage: function (color) {
      return config.glassesBaseUrl + color.image

    }
  },
};
</script>
